import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "../ThemeContext";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // -theme

  const savedTheme = localStorage.getItem("theme") || "light";
  const [theme, setTheme] = useState(savedTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMouseEnter = () => setIsDropdownOpen(true);
  const handleMouseLeave = () => setIsDropdownOpen(false);

  const toggleDropdown = (e) => {
    e.preventDefault(); // Prevent link navigation
    setIsDropdownOpen((prev) => !prev);
  };
  const [openMenu, setOpenMenu] = useState(null);

  // const handleToggle = (menuId) => {
  //   setOpenMenu((prev) => (prev === menuId ? null : menuId));
  // };
  const handleToggle = (menu) => {
    setOpenMenu((prevMenu) => (prevMenu === menu ? null : menu));
  };
  const navbarRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // hover inside menu
  const showTab = (tabId) => {
    const tabButton = document.getElementById(tabId);
    if (!tabButton) return;

    const tabContentId = tabButton.getAttribute("data-bs-target");
    if (!tabContentId) return;

    document.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.classList.remove("active");
      tab.setAttribute("aria-selected", "false");
    });

    document.querySelectorAll(".tab-pane").forEach((pane) => {
      pane.classList.remove("show", "active");
    });

    tabButton.classList.add("active");
    tabButton.setAttribute("aria-selected", "true");

    const activePane = document.querySelector(tabContentId);
    if (activePane) {
      activePane.classList.add("show", "active");
    }
  };

  useEffect(() => {
    showTab("blockchain-tab"); // default tab on load
  }, []);

  const blockchainTabs = [
    { id: "blockchain-tab", label: "Blockchain", icon: "fas fa-cubes" },
    { id: "coin-tab", label: "Coin Development", icon: "bi bi-coin" },
    { id: "defi-tab", label: "DeFi", icon: "bi bi-safe" },
    // { id: 'frm-tab', label: 'Blockchain Frameworks', icon: 'bi bi-boxes' },
    // { id: 'layer-tab', label: 'Layer 1 & Layer 2 Solutions', icon: 'bi bi-layers' },
    // { id: 'enterprise-tab', label: 'Enterprise Blockchain', icon: 'bi bi-building' },
    // { id: 'smart-tab', label: 'Smart Contract', icon: 'bi bi-file-earmark-code' },
    // { id: 'tokenization-tab', label: 'Tokenization', icon: 'bi bi-currency-bitcoin' },
    // { id: 'whitepaper-tab', label: 'Whitepaper', icon: 'bi bi-file-text' },
  ];

  const aiTabs = [
    // { id: 'ai-tab', label: 'Artificial Intelligence', icon: 'bi bi-cpu' },
    // { id: 'generative-tab', label: 'Generative AI', icon: 'bi bi-palette' },
    { id: "agents-tab", label: "AI Agents", icon: "bi bi-robot" },
  ];

  const gamingTabs = [
    { id: "gaming-tab", label: "Gaming", icon: "bi bi-controller" },
    // { id: 'metaverse-tab', label: 'Metaverse', icon: 'bi bi-globe2' },
    // { id: 'mtindustries-tab', label: 'Metaverse Industries', icon: 'bi bi-building' },
  ];

  const industryTabs = [
    { id: "home-tab", label: "Government", icon: "bi bi-bank" },
    { id: "profile-tab", label: "BFSI", icon: "bi bi-credit-card-2-front" },
    { id: "messages-tab", label: "Cloud Services", icon: "bi bi-cloud-check" },
    { id: "settings-tab", label: "Case Study", icon: "bi bi-journal-text" },
  ];

  const consulting = [
    {
      id: "consulting-tab",
      label: "Consulting",
      icon: "bi bi-person-workspace",
    },
    {
      id: "marketing-tab",
      label: "Marketing As A Service",
      icon: "bi bi-megaphone",
    },
  ];

  const exchange = [
    { id: "exchange-tab", label: "Exchange", icon: "bi bi-arrow-left-right" },
    // { id: 'wallet-tab', label: 'Wallet', icon: 'bi bi-wallet2' },
    { id: "nft-tab", label: "NFT", icon: "bi bi-image" },
    // { id: 'web3-tab', label: 'Web3', icon: 'bi bi-globe2' },
    // { id: 'digital-tab', label: 'Digital Banking', icon: 'bi bi-credit-card' },
    { id: "bots-tab", label: "Trading Bots", icon: "bi bi-robot" },
  ];

  const company = [
    { id: "company-tab", label: "Company", icon: "bi bi-buildings" },
    { id: "blog-tab", label: "Blogs", icon: "bi bi-newspaper" },
    { id: "career-tab", label: "Career", icon: "bi bi-briefcase" },
  ];

  // close menu when click menu destop screen
  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  // close menu when click menu moblie screen
  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav
        ref={navbarRef}
        className={`navbar navbar-expand-lg py-lg-0 ${
          isSticky ? "is-sticky" : ""
        }`}
      >
        <div className="container">
          <Link className="navbar-brand me-0" to="/">
            <img
              src={
                theme === "dark"
                  ? "/assets/images/logo/dark-logo.svg"
                  : "/assets/images/logo/logo.svg"
              }
              alt="Logo"
            />
          </Link>
          <div className="d-flex gap-3 align-items-center">
            <div className="d-block d-lg-none">
              <label htmlFor="switch" className="toggle_btn">
                <input
                  type="checkbox"
                  className="input"
                  id="switch"
                  onChange={toggleTheme}
                  checked={theme === "dark"}
                  readOnly
                />
                <div
                  className={`icon icon--moon ${
                    theme === "light" ? "show" : "hide"
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#000"
                    width={25}
                    height={25}
                  >
                    <path
                      fillRule="evenodd"
                      d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  className={`icon icon--sun ${
                    theme === "dark" ? "show" : "hide"
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#000"
                    width={25}
                    height={25}
                  >
                    <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
                  </svg>
                </div>
              </label>
            </div>

            <div className="d-block d-lg-none">
              <div className="bars_icon ">
                <i
                  className="fa-solid fa-bars-staggered text_24 d-block d-lg-none"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsMenuOpen(true)}
                ></i>
              </div>
            </div>
          </div>
          <div
            className={` navbar-collapse blockcryp_nav ${
              isMenuOpen ? "show" : ""
            }`}
            tabindex="-1"
            id="navbarSupportedContent"
            //    className="collapse navbar-collapse blockcryp_nav"
            // id="navbarSupportedContent"
          >
            <div className="text-end px-3 d-block d-lg-none mb-4">
              <i
                className="fa-solid fa-square-xmark text_36"
                style={{ cursor: "pointer" }}
                onClick={() => setIsMenuOpen(false)}
              ></i>
            </div>
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              {/* destop view first menu */}
              <li
                className="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    BlockChain
                  </a>
                  <svg
                    className="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          <ul
                            className="nav nav-tabs border-0 flex-column me-xl-4"
                            role="tablist"
                          >
                            {blockchainTabs.map((item) => (
                              <li
                                className="nav-item home_list"
                                role="presentation"
                                key={item.id}
                                onMouseEnter={() => showTab(item.id)}
                              >
                                <button
                                  className="air_list border-0 p-0"
                                  id={item.id}
                                  data-bs-target={`#${item.id.replace(
                                    "-tab",
                                    "",
                                  )}`}
                                  type="button"
                                  role="tab"
                                  aria-controls={item.id.replace("-tab", "")}
                                  aria-selected="false"
                                >
                                  <div className="door_icon me-xxl-3 me-2">
                                    <i className={item.icon}></i>
                                  </div>
                                  {item.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                        {/* Main Content */}
                        <div className="col-xxl-8 col-lg-9">
                          <div className="tab-content ms-4 flex-grow-1">
                            <div
                              className="tab-pane fade show active"
                              id="blockchain"
                              role="tabpanel"
                              aria-labelledby="blockchain-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Blockchain
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Navigate your journey towards blockchain
                                    with diligently crafted solutions
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/blockchain_development"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Blockchain Development</h5>
                                      <p className="sub_para mb-1">
                                        Tap into the potential of blockchain
                                        technology with our strategic blockchain
                                        services.
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Blockchain In Identity Management</h5>
                                    <p className="sub_para mb-1">
                                      Transparent and flawless identity
                                      management with blockchain.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Chain Abstraction</h5>
                                    <p className="sub_para mb-1">
                                      Leverage our chain abstraction expertise
                                      to unify multi-chain operations.
                                    </p>
                                  </div>
                                </div> */}
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/metaverse_development"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Metaverse Development</h5>
                                      <p className="sub_para mb-1">
                                        End-to-end solutions to facilitate your
                                        entry and participation in the metaverse
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Depin Development</h5>
                                    <p className="sub_para mb-1">
                                      Pioneering the future of DePIN-powered
                                      applications.
                                    </p>
                                  </div>
                                </div> */}
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/web3development"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Web 3.0 Development</h5>
                                      <p className="sub_para mb-1">
                                        Develop an en evolved web that is open,
                                        intelligent, and autonomous
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="defi"
                              role="tabpanel"
                              aria-labelledby="defi-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    DeFi
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    DeFi development services for connecting
                                    networks of collaborative ecosystems
                                  </p>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/tokenization"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Asset Tokenization</h5>
                                      <p className="sub_para mb-1">
                                        Transfer ownership & storage speedily
                                        without any centralized finance entity.
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="/defi" onClick={closeDropdown}>
                                      <h5>DeFi Development</h5>
                                      <p className="sub_para mb-1">
                                        Drive resiliency and facilitate trust
                                        with exceptional DeFi development
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>DeFi Yield Farming</h5>
                                    <p className="sub_para mb-1">
                                      Deliver business-oriented DeFi yield
                                      farming platforms that accomplish business
                                      goals
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>DeFi Staking</h5>
                                    <p className="sub_para mb-1">
                                      Staking software with market-leading
                                      features and institutional-grade security
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>DeFi Lending And Borrowing</h5>
                                    <p className="sub_para mb-1">
                                      Borrowing and lending platforms that fill
                                      the gap lagging in traditional banking
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>DeFi Lottery</h5>
                                    <p className="sub_para mb-1">
                                      Decentralized lottery ecosystem reinforced
                                      with greater security, and traceability
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>DAO Blockchain</h5>
                                    <p className="sub_para mb-1">
                                      100% transparent transactions, mandatory
                                      voting and handle services in a
                                      standardized way
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Olympus DAO Development</h5>
                                    <p className="sub_para mb-1">
                                      Introduce unique economic and
                                      game-theoretic dynamics through staking
                                      and bonding
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Dapp Development Services</h5>
                                    <p className="sub_para mb-1">
                                      Business growth with unique, innovative,
                                      secure and engaging applications
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="coin"
                              role="tabpanel"
                              aria-labelledby="coin-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Coin Development
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Coin development services for secure &
                                    transparent transactions
                                  </p>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/cryptocurrency"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Cryptocurrency Exchange</h5>
                                      <p className="sub_para mb-1">
                                        We Engineer Secure, Scalable Platforms
                                        For Crypto Asset Trading And Liquidity
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Meme Coin Development</h5>
                                    <p className="sub_para mb-1">
                                      Craft your own meme coin today and live
                                      with the trend.
                                    </p>
                                  </div>
                                </div> */}

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/tokencoin"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Coin/Token Development</h5>
                                      <p className="sub_para mb-1">
                                        Best services for crypto coin/token
                                        development to match your business
                                        goals.
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/smartcontract"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Smart Contract Development</h5>
                                      <p className="sub_para mb-1">
                                        Achieve business automation with
                                        advanced smart contract development
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Stablecoin Development</h5>
                                    <p className="sub_para mb-1">
                                      Deploy gold-backed stablecoins to navigate
                                      your coin development journey.
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>IDO Development</h5>
                                    <p className="sub_para mb-1">
                                      Create a coherent roadmap to navigate your
                                      IDO development journey.
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>ICO Development</h5>
                                    <p className="sub_para mb-1">
                                      Maximize fundraising opportunities and
                                      drive innovation with ICO development.
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Launchpad Development</h5>
                                    <p className="sub_para mb-1">
                                      Build a launchpad to capitalize on the
                                      revenue generation opportunity.
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="frm"
                              role="tabpanel"
                              aria-labelledby="frm-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Blockchain Frameworks
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Navigate your journey towards blockchain
                                    with diligently crafted solutions
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Parity Substrate</h5>
                                    <p className="sub_para mb-1">
                                      Enables opportunities in substrate-based
                                      blockchain development.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Op Stack</h5>
                                    <p className="sub_para mb-1">
                                      Supports digital infrastructure with OP
                                      Stack solutions.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Arbitrum Orbit</h5>
                                    <p className="sub_para mb-1">
                                      Offers scalability and efficiency via the
                                      Arbitrum Orbit solution.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Cosmos SDK</h5>
                                    <p className="sub_para mb-1">
                                      Allows development of custom chains to
                                      boost business growth.
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Polygon Zkevm</h5>
                                    <p className="sub_para mb-1">
                                      Enhances Ethereum scalability through
                                      Polygon zkEVM.
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Zksync Hyperchains</h5>
                                    <p className="sub_para mb-1">
                                      Delivers interoperable and efficient
                                      blockchain solutions via zkSync
                                      Hyperchains.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="layer"
                              role="tabpanel"
                              aria-labelledby="layer-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Layer 1 & Layer 2 Solutions
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Participate in the blockchain market with a
                                    secure blockchain network
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>BSC</h5>
                                    <p className="sub_para mb-1">
                                      Use BSC as the right option for
                                      decentralized application development.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Ethereum</h5>
                                    <p className="sub_para mb-1">
                                      Launch next-gen secure and scalable
                                      platforms with Ethereum Blockchain
                                      solutions.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Solana</h5>
                                    <p className="sub_para mb-1">
                                      Empower decentralized application
                                      development in a more efficient manner.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Polkadot</h5>
                                    <p className="sub_para mb-1">
                                      Cover data across public, private, open &
                                      permission-less blockchain networks.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Cardano</h5>
                                    <p className="sub_para mb-1">
                                      Develop & deploy fast, scalable, and
                                      eco-friendly dApps with Cardano
                                      blockchain.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>SUI Blockchain Development</h5>
                                    <p className="sub_para mb-1">
                                      Launch scalable Web3 solutions with Sui
                                      blockchain.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="enterprise"
                              role="tabpanel"
                              aria-labelledby="enterprise-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Enterprise Blockchain
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Modular blockchain solutions for a smart,
                                    safe, and sustainable enterprise ecosystem
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Entertainment</h5>
                                    <p className="sub_para mb-1">
                                      Achieve better visibility across content
                                      creation and distribution lifecycle.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Education</h5>
                                    <p className="sub_para mb-1">
                                      Improve accessibility, credibility, &
                                      transparency in the education industry.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Supply Chain</h5>
                                    <p className="sub_para mb-1">
                                      Total visibility, transparency, &
                                      full-asset control across a supply chain
                                      network.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Finance</h5>
                                    <p className="sub_para mb-1">
                                      Bring greater security, transparency, and
                                      speed to financial transactions.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Transport And Logistics</h5>
                                    <p className="sub_para mb-1">
                                      Embrace augmented security, trust in data,
                                      and logistics management.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Healthcare</h5>
                                    <p className="sub_para mb-1">
                                      Eliminate issues of fraud and expensive
                                      treatments in healthcare.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Real Estate</h5>
                                    <p className="sub_para mb-1">
                                      Minimize data silos and ensure
                                      transparency at abbreviated costs.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Procure-To-Pay</h5>
                                    <p className="sub_para mb-1">
                                      Enhance the management of goods, services
                                      & resources with PTP.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Carbon Credits</h5>
                                    <p className="sub_para mb-1">
                                      Better transparency, access &
                                      standardization for the carbon markets.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="smart"
                              role="tabpanel"
                              aria-labelledby="smart-tab2"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Smart Contract
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Secure and dependable smart contracts on
                                    Ethereum, EOS, Hyperledger, TRON and more
                                  </p>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Smart Contract Audit</h5>
                                    <p className="sub_para mb-1">
                                      Audit smart contracts for errors, security
                                      flaws, & compilation issues
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="tokenization"
                              role="tabpanel"
                              aria-labelledby="tokenization-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Tokenization
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Navigate towards an era of asset-backed
                                    tokenization for new possibilities
                                  </p>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="">
                                      <h5>Real Estate Tokenization</h5>
                                      <p className="sub_para mb-1">
                                        Transforming Property Ownership with
                                        Real Estate Tokenization.
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="">
                                      <h5>
                                        Fund Tokenization Development Services
                                      </h5>
                                      <p className="sub_para mb-1">
                                        Streamline Asset Management with Fund
                                        Tokenization!
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="">
                                      <h5>Gold Tokenization</h5>
                                      <p className="sub_para mb-1">
                                        Gold Tokenization enables businesses to
                                        transition to blockchain-based gold
                                        investments.
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="">
                                      <h5>Asset Management</h5>
                                      <p className="sub_para mb-1">
                                        Steer funds in high-performing asset
                                        tokens and digital products across
                                        exchanges.
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="">
                                      <h5>White Label Tokenization</h5>
                                      <p className="sub_para mb-1">
                                        Drive Growth with Customized White-Label
                                        Real World Asset Tokenization Solutions.
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="whitepaper"
                              role="tabpanel"
                              aria-labelledby="whitepaper-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Whitepaper
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Craft detailed & technically sound
                                    whitepapers that investors want to read
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="">
                                      <h5>White Paper Development</h5>
                                      <p className="sub_para mb-1">
                                        Build a strong foundation for your
                                        project with a mission-driven white
                                        paper
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* destop view second menu */}
              <li
                className="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    AI
                  </a>
                  <svg
                    className="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          <ul
                            className="nav nav-tabs border-0 flex-column me-xl-4"
                            role="tablist"
                          >
                            {aiTabs.map((item) => (
                              <li
                                className="nav-item home_list"
                                role="presentation"
                                key={item.id}
                                onMouseEnter={() => showTab(item.id)}
                              >
                                <button
                                  className="air_list border-0 p-0"
                                  id={item.id}
                                  data-bs-target={`#${item.id.replace(
                                    "-tab",
                                    "",
                                  )}`}
                                  type="button"
                                  role="tab"
                                  aria-controls={item.id.replace("-tab", "")}
                                  aria-selected="false"
                                >
                                  <div className="door_icon me-xxl-3 me-2">
                                    <i className={item.icon}></i>
                                  </div>
                                  {item.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-xxl-8 col-lg-9">
                          <div className="tab-content ms-4 flex-grow-1">
                            <div
                              className="tab-pane fade"
                              id="ai"
                              role="tabpanel"
                              aria-labelledby="ai-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Artificial Intelligence
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Unlock the power of AI & ML to restructure
                                    your approach towards business operations
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5> AI Ml Solutions</h5>
                                    <p className="sub_para mb-1">
                                      Capitalize on the potential of AI & ML for
                                      strategic business operations
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="generative"
                              role="tabpanel"
                              aria-labelledby="generative-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Generative AI
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Automate your business innovation and growth
                                    with generative AI development
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5> Generative Ai Development</h5>
                                    <p className="sub_para mb-1">
                                      Stay ahead of the AI curve with our
                                      generative AI development services
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade  show active"
                              id="agents"
                              role="tabpanel"
                              aria-labelledby="agents-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    AI Agents
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Supercharge your Workflows with our AI Agent
                                    Solutions
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="/aidevelopment">
                                      <h5> AI Agent Development</h5>
                                      <p className="sub_para mb-1">
                                        Transforming Industries with our
                                        Intelligent AI Agent Solutions
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings"
                              role="tabpanel"
                              aria-labelledby="settings-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Case Study
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Check out our proudest achievements here.
                                    Explore how we strategize, perform, and
                                    ensure client satisfaction
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>CBDC</h5>
                                    <p className="sub_para mb-1">
                                      Leverage near real-time data with a
                                      monetary system to solidify banking
                                      systems.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>KYC & AML</h5>
                                    <p className="sub_para mb-1">
                                      Streamline the KYC process and manage the
                                      entire user lifecycle.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Trade Finance</h5>
                                    <p className="sub_para mb-1">
                                      Embrace greater speed, security, &
                                      transparency in transactions.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Insurance</h5>
                                    <p className="sub_para mb-1">
                                      BFSI products that help cut costs, save
                                      resources, and stay compliant.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings2"
                              role="tabpanel"
                              aria-labelledby="settings-tab2"
                            >
                              <h4> Listing</h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings3"
                              role="tabpanel"
                              aria-labelledby="settings-tab3"
                            >
                              <h4>Airdrop </h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings4"
                              role="tabpanel"
                              aria-labelledby="settings-tab4"
                            >
                              <h4>Airdrop Listing</h4>
                              <p>Promote your project via strategic airdrop.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* destop view three menu */}
              <li
                className="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    Gaming
                  </a>
                  <svg
                    className="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          <ul
                            className="nav nav-tabs border-0 flex-column me-xl-4"
                            role="tablist"
                          >
                            {gamingTabs.map((item) => (
                              <li
                                className="nav-item home_list"
                                role="presentation"
                                key={item.id}
                                onMouseEnter={() => showTab(item.id)}
                              >
                                <button
                                  className="air_list border-0 p-0"
                                  id={item.id}
                                  data-bs-target={`#${item.id.replace(
                                    "-tab",
                                    "",
                                  )}`}
                                  type="button"
                                  role="tab"
                                  aria-controls={item.id.replace("-tab", "")}
                                  aria-selected="false"
                                >
                                  <div className="door_icon me-xxl-3 me-2">
                                    <i className={item.icon}></i>
                                  </div>
                                  {item.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-xxl-8 col-lg-9">
                          <div className="tab-content ms-4 flex-grow-1">
                            <div
                              className="tab-pane fade show active"
                              id="gaming"
                              role="tabpanel"
                              aria-labelledby="gaming-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Gaming Services Offered
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Get ready to embark on an epic journey of
                                    gaming development!
                                  </p>
                                </div>
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5> AAA Game Development</h5>
                                    <p className="sub_para mb-1">
                                      Full-scale game development from concept
                                      to blockbuster.
                                    </p>
                                  </div>
                                </div> */}
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link to="/gaming">
                                      <h5> Game Development</h5>
                                      <p className="sub_para mb-1">
                                        Covers the full spectrum from character
                                        design to coding.
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>P2E Game Development (Play to Earn)</h5>
                                    <p className="sub_para mb-1">
                                      Monetized games with expert-led
                                      development to bring your idea to life.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5> Tap To Earn Game</h5>
                                    <p className="sub_para mb-1">
                                      Games where each interaction can turn into
                                      real value.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Hyper Casual Game Development</h5>
                                    <p className="sub_para mb-1">
                                      Fast-paced, simple, yet addictive games
                                      designed for all players.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Telegram Game Development</h5>
                                    <p className="sub_para mb-1">
                                      Games specifically developed for Telegram
                                      with user engagement focus.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>NFT Gaming</h5>
                                    <p className="sub_para mb-1">
                                      Games with rare digital assets like
                                      weapons, skins, characters.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Web3 Game Development</h5>
                                    <p className="sub_para mb-1">
                                      Enhanced gaming with Web 3.0 technologies.
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Blockchain Game Development</h5>
                                    <p className="sub_para mb-1">
                                      Blockchain-based games with decentralized
                                      mechanics.
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="metaverse"
                              role="tabpanel"
                              aria-labelledby="metaverse-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Gaming Services Offered
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Get ready to embark on an epic journey of
                                    gaming development!
                                  </p>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse App Development</h5>
                                    <p className="sub_para mb-1">
                                      Tap into the metaverse with
                                      enterprise-focused application development
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse Game</h5>
                                    <p className="sub_para mb-1">
                                      Bring About a Revolution in the World of
                                      Gaming with the Metaverse
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>White Label Metaverse</h5>
                                    <p className="sub_para mb-1">
                                      Customizable white label metaverse
                                      solutions to launch your virtual world
                                      fast
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse Events</h5>
                                    <p className="sub_para mb-1">
                                      Organize unforgettable metaverse events
                                      using our expertise
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse Avatar Development</h5>
                                    <p className="sub_para mb-1">
                                      Personalize and create cartoon avatar
                                      using our craftsmanship
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Build In Metaverse</h5>
                                    <p className="sub_para mb-1">
                                      Create seamless experiences across leading
                                      third party metaverse platforms
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>AI Agent Development</h5>
                                    <p className="sub_para mb-1">
                                      Transforming Industries with our
                                      Intelligent AI Agent Solutions
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="mtindustries"
                              role="tabpanel"
                              aria-labelledby="mtindustries-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Metaverse Industries
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Metaverse Revolution Transforming Industries
                                    Across the BoardF
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse Casino Game</h5>
                                    <p className="sub_para mb-1">
                                      Transforming Casino Gaming for the
                                      Metaverse Era with Virtual Jackpots
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse In The Healthcare</h5>
                                    <p className="sub_para mb-1">
                                      Deliver cost-effective treatments and
                                      improve healthcare outcomes with Metaverse
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse In The Manufacturing</h5>
                                    <p className="sub_para mb-1">
                                      Empower design engineers to collaborate
                                      and create visual designs remotely
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse For Education</h5>
                                    <p className="sub_para mb-1">
                                      Enter into the future of learning by
                                      implementing metaverse in education
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse In Ecommerce</h5>
                                    <p className="sub_para mb-1">
                                      Accelerate your business with our
                                      cutting-edge Metaverse e-commerce platform
                                      development.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse Real Estate</h5>
                                    <p className="sub_para mb-1">
                                      Unlock a new dimension of real estate with
                                      Metaverse
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse In Food Industry</h5>
                                    <p className="sub_para mb-1">
                                      Dive into the exciting world of Metaverse
                                      restaurants with our team
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse 3D Space</h5>
                                    <p className="sub_para mb-1">
                                      Bringing imagination to life in the
                                      digital realm with immersive virtual
                                      worlds
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Metaverse Virtual Office</h5>
                                    <p className="sub_para mb-1">
                                      Experience the evolution of work with our
                                      futuristic metaverse working spaces
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings"
                              role="tabpanel"
                              aria-labelledby="settings-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Case Study
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Check out our proudest achievements here.
                                    Explore how we strategize, perform, and
                                    ensure client satisfaction
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>CBDC</h5>
                                    <p className="sub_para mb-1">
                                      Leverage near real-time data with a
                                      monetary system to solidify banking
                                      systems.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>KYC & AML</h5>
                                    <p className="sub_para mb-1">
                                      Streamline the KYC process and manage the
                                      entire user lifecycle.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Trade Finance</h5>
                                    <p className="sub_para mb-1">
                                      Embrace greater speed, security, &
                                      transparency in transactions.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Insurance</h5>
                                    <p className="sub_para mb-1">
                                      BFSI products that help cut costs, save
                                      resources, and stay compliant.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings2"
                              role="tabpanel"
                              aria-labelledby="settings-tab2"
                            >
                              <h4> Listing</h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings3"
                              role="tabpanel"
                              aria-labelledby="settings-tab3"
                            >
                              <h4>Airdrop </h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="settings4"
                              role="tabpanel"
                              aria-labelledby="settings-tab4"
                            >
                              <h4>Airdrop Listing</h4>
                              <p>Promote your project via strategic airdrop.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* destop view four menu */}
              {/* <li
                className="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    Industries
                  </a>
                  <svg
                    className="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          <ul className="nav nav-tabs border-0 flex-column me-xl-4" role="tablist">
                            {industryTabs.map((item) => (
                              <li className="nav-item home_list" role="presentation" key={item.id} onMouseEnter={() => showTab(item.id)}>
                                <button
                                  className="air_list border-0 p-0"
                                  id={item.id}
                                  data-bs-target={`#${item.id.replace('-tab', '')}`}
                                  type="button"
                                  role="tab"
                                  aria-controls={item.id.replace('-tab', '')}
                                  aria-selected="false"
                                >
                                  <div className="door_icon me-xxl-3 me-2">
                                    <i className={item.icon}></i>
                                  </div>
                                  {item.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-xxl-8 col-lg-9">
                          <div className="tab-content ms-4 flex-grow-1">
                            <div
                              className="tab-pane fade show active"
                              id="home"
                              role="tabpanel"
                              aria-labelledby="home-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Government
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Share data over a distributed ledger that is
                                    secured using cryptography
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>G2C</h5>
                                    <p className="sub_para mb-1">
                                      Improve existing G2C services with
                                      blockchain-driven intelligent analytics.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Digital Identity</h5>
                                    <p className="sub_para mb-1">
                                      Secure digital identities with a
                                      decentralized digital identity management
                                      system.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Government Data Storage</h5>
                                    <p className="sub_para mb-1">
                                      Utilize Blockchain-based data storage
                                      systems to store and secure data.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>E-Voting System</h5>
                                    <p className="sub_para mb-1">
                                      Securing the way e-voting works through
                                      decentralized blockchain technology.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <h5>Government Regulatory Systems</h5>
                                    <p className="sub_para mb-1">
                                      Enhancing democratic, open, and
                                      self-reliance government regulatory
                                      system.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="profile"
                              role="tabpanel"
                              aria-labelledby="profile-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    BFSI
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Launch your digital asset bank with digital
                                    banking solutions
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>CBDC</h5>
                                    <p class="sub_para mb-1">
                                      Leverage near real-time data with a
                                      monetary system to solidify banking
                                      systems.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>KYC & AML</h5>
                                    <p class="sub_para mb-1">
                                      Streamline the KYC process and manage the
                                      entire user lifecycle.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Trade Finance</h5>
                                    <p class="sub_para mb-1">
                                      Embrace greater speed, security, &
                                      transparency in transactions.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Insurance</h5>
                                    <p class="sub_para mb-1">
                                      BFSI products that help cut costs, save
                                      resources, and stay compliant.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="messages"
                              role="tabpanel"
                              aria-labelledby="messages-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Cloud Services
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Tailored AWS solutions for scalability,
                                    security, cost-efficiency, and growth.
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5> AWS Services</h5>
                                    <p class="sub_para mb-1">
                                      Optimize, secure, and scale your cloud
                                      infrastructure with our AWS solutions.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings"
                              role="tabpanel"
                              aria-labelledby="settings-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Case Study
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Check out our proudest achievements here.
                                    Explore how we strategize, perform, and
                                    ensure client satisfaction
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>CBDC</h5>
                                    <p class="sub_para mb-1">
                                      Leverage near real-time data with a
                                      monetary system to solidify banking
                                      systems.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>KYC & AML</h5>
                                    <p class="sub_para mb-1">
                                      Streamline the KYC process and manage the
                                      entire user lifecycle.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Trade Finance</h5>
                                    <p class="sub_para mb-1">
                                      Embrace greater speed, security, &
                                      transparency in transactions.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Insurance</h5>
                                    <p class="sub_para mb-1">
                                      BFSI products that help cut costs, save
                                      resources, and stay compliant.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings2"
                              role="tabpanel"
                              aria-labelledby="settings-tab2"
                            >
                              <h4> Listing</h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings3"
                              role="tabpanel"
                              aria-labelledby="settings-tab3"
                            >
                              <h4>Airdrop </h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings4"
                              role="tabpanel"
                              aria-labelledby="settings-tab4"
                            >
                              <h4>Airdrop Listing</h4>
                              <p>Promote your project via strategic airdrop.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li> */}
              {/* destop view five menu */}
              {/* <li
                class="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    Consulting
                  </a>
                  <svg
                    class="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          {consulting.map((item) => (
                            <li className="nav-item home_list" role="presentation" key={item.id} onMouseEnter={() => showTab(item.id)}>
                              <button
                                className="air_list border-0 p-0"
                                id={item.id}
                                data-bs-target={`#${item.id.replace('-tab', '')}`}
                                type="button"
                                role="tab"
                                aria-controls={item.id.replace('-tab', '')}
                                aria-selected="false"
                              >
                                <div className="door_icon me-xxl-3 me-2">
                                  <i className={item.icon}></i>
                                </div>
                                {item.label}
                              </button>
                            </li>
                          ))}
                        </div>
                        <div className="col-xxl-8 col-lg-9">
                          <div class="tab-content ms-4 flex-grow-1">
                            <div
                              class="tab-pane fade show active"
                              id="consulting"
                              role="tabpanel"
                              aria-labelledby="consulting-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Consulting
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    We empower your business through blockchain
                                    consulting expertise that provides lasting
                                    gains.
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Blockchain Consulting Company</h5>
                                    <p class="sub_para mb-1">
                                      Ours is a blockchain consulting and
                                      solution provider company. You idealize,
                                      we realize!
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Web3 Consulting Company</h5>
                                    <p class="sub_para mb-1">
                                      Creating Web3 ecosystems for leveraging
                                      the benefits of blockchain technology
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Metaverse Consulting Company</h5>
                                    <p class="sub_para mb-1">
                                      Metaverse consulting services to guide you
                                      on the right path
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>AI Consulting Company</h5>
                                    <p class="sub_para mb-1">
                                      Our motive is to fully realise business
                                      benefits using our expertise in AI, the
                                      transformative technology.
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>DeFi Consulting Services</h5>
                                    <p class="sub_para mb-1">
                                      Maximize your DeFi project’s success with
                                      tailored DeFi consulting services. Unlock
                                      new business opportunities.
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>DAO Consulting Services</h5>
                                    <p class="sub_para mb-1">
                                      Get goal-specific DAO consulting services
                                      from our industry experts
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="marketing"
                              role="tabpanel"
                              aria-labelledby="marketing-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Marketing As A Service (MAAS)
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Elevate Your Web3 Projects with Our
                                    Comprehensive Marketing Approach
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Marketing As A Service</h5>
                                    <p class="sub_para mb-1">
                                      We deliver tailor-made and agile marketing
                                      solutions that unlock your project’s full
                                      potential.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="messages"
                              role="tabpanel"
                              aria-labelledby="messages-tab"
                            >
                              <h4>CMS & CG Listing</h4>
                              <p>
                                Integration with CoinMarketCap, CoinGecko, and
                                CMS systems.
                              </p>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings"
                              role="tabpanel"
                              aria-labelledby="settings-tab"
                            >
                              <h4>Airdrop Listing</h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings2"
                              role="tabpanel"
                              aria-labelledby="settings-tab2"
                            >
                              <h4> Listing</h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings3"
                              role="tabpanel"
                              aria-labelledby="settings-tab3"
                            >
                              <h4>Airdrop </h4>
                              <p>
                                Promote your project via strategic airdrop
                                campaigns.
                              </p>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="settings4"
                              role="tabpanel"
                              aria-labelledby="settings-tab4"
                            >
                              <h4>Airdrop Listing</h4>
                              <p>Promote your project via strategic airdrop.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li> */}
              {/* destop view six menu */}
              <li
                class="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    Solutions
                  </a>
                  <svg
                    className="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          {exchange.map((item) => (
                            <li
                              className="nav-item home_list"
                              role="presentation"
                              key={item.id}
                              onMouseEnter={() => showTab(item.id)}
                            >
                              <button
                                className="air_list border-0 p-0"
                                id={item.id}
                                data-bs-target={`#${item.id.replace(
                                  "-tab",
                                  "",
                                )}`}
                                type="button"
                                role="tab"
                                aria-controls={item.id.replace("-tab", "")}
                                aria-selected="false"
                              >
                                <div className="door_icon me-xxl-3 me-2">
                                  <i className={item.icon}></i>
                                </div>
                                {item.label}
                              </button>
                            </li>
                          ))}
                        </div>
                        <div className="col-xxl-8 col-lg-9">
                          <div class="tab-content ms-4 flex-grow-1">
                            <div
                              class="tab-pane fade show active"
                              id="exchange"
                              role="tabpanel"
                              aria-labelledby="exchange-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Exchange
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Enter the market with the best-in-class
                                    crypto exchange development services
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <Link to="/exchange">
                                      <h5>Custom Exchange</h5>
                                      <p class="sub_para mb-1">
                                        Develop your competitive
                                        enterprise-level custom exchange from
                                        scratch
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>White Label Exchange</h5>
                                    <p class="sub_para mb-1">
                                      Gear up your revenue stream using a
                                      ready-made white label exchange
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Derivatives Exchange</h5>
                                    <p class="sub_para mb-1">
                                      Assured platform liquidity & returns for a
                                      huge pool of crypto investors
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Decentralized Exchange</h5>
                                    <p class="sub_para mb-1">
                                      Reduce your time-to-market with a
                                      customized DEX exchange script solution
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Centralized Exchange</h5>
                                    <p class="sub_para mb-1">
                                      Facilitate digital asset trading in a
                                      secure and convenient environment
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>P2P Exchange</h5>
                                    <p class="sub_para mb-1">
                                      Use a smart contract-based Escrow system
                                      to foster reliable transactions
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Margin Trading Exchangee</h5>
                                    <p class="sub_para mb-1">
                                      Secure and feature-rich margin trading
                                      exchange to disrupt the digital market
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Market Making Services</h5>
                                    <p class="sub_para mb-1">
                                      Intensify liquidity provisioning with
                                      perfect market making strategies
                                    </p>
                                  </div>
                                </div> */}
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Prediction Marketplaces</h5>
                                    <p class="sub_para mb-1">
                                      Let Users Bet & Win Big with AI Prediction
                                      Markets
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="wallet"
                              role="tabpanel"
                              aria-labelledby="wallet-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Wallet
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Solutions that help users enjoy transactions
                                    in a speedier & secure environment
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Digital Wallet</h5>
                                    <p class="sub_para mb-1">
                                      Robust & secure wallet solutions for
                                      storing & transferring digital assets
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Super App Development</h5>
                                    <p class="sub_para mb-1">
                                      Unlock the power of an inventive super
                                      crypto app integrated with enticing
                                      revenue prospects.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>DeFi Wallet</h5>
                                    <p class="sub_para mb-1">
                                      A wallet that is fortified from hacks, &
                                      immune to cross-border regulations
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Web3 Wallet</h5>
                                    <p class="sub_para mb-1">
                                      Access data in real time with trustless
                                      Web3 blockchain ecosystems
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>White Label Wallet</h5>
                                    <p class="sub_para mb-1">
                                      Ready-to-deploy white label wallet with
                                      high-grade security features
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Multicurrency Wallet</h5>
                                    <p class="sub_para mb-1">
                                      Deploy wallets that are intuitive,
                                      user-friendly, secure & scalable
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>TRON Wallet</h5>
                                    <p class="sub_para mb-1">
                                      Tron wallet holds private keys & TRX coins
                                      securely within itself.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>MPC Crypto Wallet</h5>
                                    <p class="sub_para mb-1">
                                      MPC wallet streamlines digital asset
                                      access & safeguards private keys from
                                      vulnerabilities.
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>AI Crypto Wallet</h5>
                                    <p class="sub_para mb-1">
                                      Secure your digital assets with our AI
                                      Crypto Wallet solutions!
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade "
                              id="nft"
                              role="tabpanel"
                              aria-labelledby="nft-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    NFT
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Solutions that help users enjoy transactions
                                    in a speedier & secure environment
                                  </p>
                                </div>
                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>NFT Development</h5>
                                    <p class="sub_para mb-1">
                                      Build decentralized non-fungible tokens
                                      aligned with different business needs
                                    </p>
                                  </div>
                                </div> */}

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <Link to="/nftmarketplace">
                                      <h5>NFT Marketplace</h5>
                                      <p class="sub_para mb-1">
                                        Top-performing marketplaces for users to
                                        mint, sell, buy, and trade NFTs
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>White Label NFT Marketplace</h5>
                                    <p class="sub_para mb-1">
                                      Get a customized white label NFT
                                      marketplace with multi-platform support
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>NFT Music</h5>
                                    <p class="sub_para mb-1">
                                      Customer-centric marketplace for selling,
                                      trading and auctioning music NFTs
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Semi Fungible Token</h5>
                                    <p class="sub_para mb-1">
                                      Easy batch token transfers that support
                                      both NFTs and fungible tokens
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>NFT Art</h5>
                                    <p class="sub_para mb-1">
                                      Tokenize digital and physical assets into
                                      a one-of-a-kind, untransferable NFT
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>NFT Generative Art</h5>
                                    <p class="sub_para mb-1">
                                      Future ready NFT generative art
                                      marketplace that supports pictures, videos
                                      and GIFs
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>NFT Loan</h5>
                                    <p class="sub_para mb-1">
                                      Facilitate your participation in
                                      revolutionized borrowing & lending world
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>

                            <div
                              class="tab-pane fade"
                              id="web3"
                              role="tabpanel"
                              aria-labelledby="web3-tab2"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    web3
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Augment your marketing infrastructure with
                                    Big Data, AI, & machine learning
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="tab-pane fade"
                              id="digital"
                              role="tabpanel"
                              aria-labelledby="digital-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Digital Banking
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Empowering millions of digital assets
                                    holders to use digital banking facilities
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Digital Banking</h5>
                                    <p class="sub_para mb-1">
                                      Digital bank with industry-leading
                                      features and state-of-the-art
                                      infrastructure
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>White Label Banking</h5>
                                    <p class="sub_para mb-1">
                                      Speed up your bank launch with
                                      state-of-the-art white label solutions
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>White Label Neo Bank</h5>
                                    <p class="sub_para mb-1">
                                      Step into the future of finance with our
                                      comprehensive White Label Neo Bank
                                      Development platform!
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>BaaS Development</h5>
                                    <p class="sub_para mb-1">
                                      Unlock Blockchain & Neo-Banking with BaaS
                                      and White Label Solutions
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Payment Gateway</h5>
                                    <p class="sub_para mb-1">
                                      Get Customized Payment Gateway Solutions
                                      For Secured Transactions
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>P2P Lending</h5>
                                    <p class="sub_para mb-1">
                                      Tap into the billion-dollar lending market
                                      with a P2P lending platform
                                    </p>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Stablecoin Remittance Platform</h5>
                                    <p class="sub_para mb-1">
                                      Build your own tailored stablecoin
                                      remittance platform from scratch
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="tab-pane fade"
                              id="bots"
                              role="tabpanel"
                              aria-labelledby="bots-tab"
                            >
                              <div class="row g-4">
                                <div className="col-12">
                                  <h4 class="content-title mb-2 fw-bold">
                                    Trading Bots
                                  </h4>
                                  <p class="sub_para mb-xl-4 mb-0">
                                    Paving your path to steady profits with
                                    bespoke automated trading bot solutions
                                  </p>
                                </div>
                                <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <Link to="/botdevelopment">
                                      <h5>Arbitrage Bots</h5>
                                      <p class="sub_para mb-1">
                                        Elevate your trading strategies using
                                        powerful arbitrage bots.
                                      </p>
                                    </Link>
                                  </div>
                                </div>

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Flash Loan Arbitrage Bot</h5>
                                    <p class="sub_para mb-1">
                                      Explore flash loan arbitrage bots to
                                      conveniently execute your trading
                                      strategy.
                                    </p>
                                  </div>
                                </div> */}

                                {/* <div class="col-md-4">
                                  <div class="card glass-effect">
                                    <h5>Trading Bot</h5>
                                    <p class="sub_para mb-1">
                                      Build your AI trading bots to set your
                                      trades on Autopilot.
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
              {/* destop view seven menu */}
              <li
                class="nav-item dropdown fullwidth d-none d-lg-block"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div className="bottom_line">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={toggleDropdown}
                  >
                    About Us
                  </a>
                  <svg
                    className="icon"
                    width="14"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                  >
                    <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                  </svg>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-nav dropdown-menu dropdown-content inner_menu">
                    <div className="heading_menu">
                      <div className="row">
                        <div className="col-xxl-3 col-lg-3">
                          {company.map((item) => (
                            <li
                              className="nav-item home_list"
                              role="presentation"
                              key={item.id}
                              onMouseEnter={() => showTab(item.id)}
                            >
                              <button
                                className="air_list border-0 p-0"
                                id={item.id}
                                data-bs-target={`#${item.id.replace(
                                  "-tab",
                                  "",
                                )}`}
                                type="button"
                                role="tab"
                                aria-controls={item.id.replace("-tab", "")}
                                aria-selected="false"
                              >
                                <div className="door_icon me-xxl-3 me-2">
                                  <i className={item.icon}></i>
                                </div>
                                {item.label}
                              </button>
                            </li>
                          ))}
                        </div>
                        {/* Main Content */}
                        <div className="col-xxl-8 col-lg-9">
                          <div className="tab-content ms-4 flex-grow-1">
                            <div
                              className="tab-pane fade show active"
                              id="company"
                              role="tabpanel"
                              aria-labelledby="company-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Company
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Seize opportunities from disruption to
                                    deliver transformational outcomes for a
                                    decentralized digital world
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <div class="card glass-effect">
                                    <Link to="/about" onClick={closeDropdown}>
                                      <h5>About Us</h5>
                                      <p class="sub_para mb-1">
                                        Fostering innovation to steer digital
                                        transformation
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div class="card glass-effect">
                                    <Link
                                      to="/partners"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Partners</h5>
                                      <p class="sub_para mb-1">
                                        Our partner-centric programs equip
                                        partners with what they require
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div class="card glass-effect">
                                    <Link to="/contact" onClick={closeDropdown}>
                                      <h5>Contact Us</h5>
                                      <p class="sub_para mb-1">
                                        Get in touch with us for a friendly chat
                                        to work out if we can help
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card glass-effect">
                                    <Link
                                      to="/productdetails"
                                      onClick={closeDropdown}
                                    >
                                      <h5>Product Details</h5>
                                      <p className="sub_para mb-1">
                                        Explore our range of custom blockchain,
                                        Web3, and AI products
                                      </p>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="blog"
                              role="tabpanel"
                              aria-labelledby="blog-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Blogs
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Explore insights, trends, and tips to
                                    elevate your blockchain and Web3 journey.
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <Link to="/Blog">
                                    <div className="card glass-effect">
                                      <h5> Blog</h5>
                                      <p className="sub_para mb-1">
                                        The ultimate resource guidebook for all
                                        things blockchain-related
                                      </p>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="career"
                              role="tabpanel"
                              aria-labelledby="career-tab"
                            >
                              <div className="row g-4">
                                <div className="col-12">
                                  <h4 className="content-title mb-2 fw-bold">
                                    Career
                                  </h4>
                                  <p className="sub_para mb-xl-4 mb-0">
                                    Interested in making a career in emerging
                                    decentralized technology? Let Blockcryp help
                                    you explore the opportunities!
                                  </p>
                                </div>
                                <div className="col-md-4">
                                  <Link to="/career">
                                    <div className="card glass-effect">
                                      <h5> Career</h5>
                                      <p className="sub_para mb-1">
                                        Explore current opportunities and job
                                        openings at Blockcryp
                                      </p>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>

              {/* mobile view first menu */}
              <li
                className={`mb-1 mobile_nav_menus d-lg-none d-block ${
                  openMenu === "blockChain" ? "active" : ""
                }`}
              >
                <div
                  className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                  data-bs-toggle="collapse"
                  onClick={() => handleToggle("blockChain")}
                  data-bs-target="#blockChain-collapse5"
                  // aria-expanded="false"
                  aria-expanded={openMenu === "blockChain"}
                >
                  <div className="d-flex align-items-center">
                    <div class="door_icon me-xxl-3 me-2">
                      {/* <i class="bi bi-house-door-fill"></i> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="15"
                        viewBox="0 0 13 15"
                        fill="none"
                      >
                        <path
                          d="M6.08528 7.14878C6.10317 7.15645 6.11851 7.16412 6.13641 7.16924V10.6414L3.20879 9.17638C3.12186 9.13292 3.06817 9.04599 3.06817 8.94883V5.83974L6.08528 7.14878ZM6.69891 7.14878C6.68101 7.15645 6.66567 7.16412 6.64778 7.16924V10.6414L9.57539 9.17638C9.66233 9.13292 9.71602 9.04599 9.71602 8.94883V5.83712L6.69891 7.14878ZM9.56189 4.87898L6.49371 3.54625C6.42851 3.51812 6.355 3.51812 6.28981 3.54625L3.22162 4.87898C3.1283 4.91925 3.06757 5.01194 3.06757 5.11357C3.06757 5.21521 3.12766 5.30789 3.22162 5.34816L6.28981 6.6809C6.32241 6.69496 6.35692 6.70199 6.39144 6.70199C6.42596 6.70199 6.46047 6.69496 6.49307 6.6809L9.56125 5.34816C9.65458 5.30789 9.7153 5.21521 9.7153 5.11357C9.7153 5.01194 9.65522 4.91925 9.56125 4.87898H9.56189ZM6.39209 0C5.89863 0 5.4972 0.401416 5.4972 0.894895C5.4972 1.38837 5.89862 1.78979 6.39209 1.78979C6.88557 1.78979 7.28699 1.38837 7.28699 0.894895C7.28699 0.401416 6.88557 0 6.39209 0ZM6.39209 12.5283C5.89863 12.5283 5.4972 12.9297 5.4972 13.4232C5.4972 13.9167 5.89862 14.3181 6.39209 14.3181C6.88557 14.3181 7.28699 13.9167 7.28699 13.4232C7.28699 12.9297 6.88557 12.5283 6.39209 12.5283ZM11.8893 9.46015C11.3958 9.46015 10.9944 9.86156 10.9944 10.355C10.9944 10.8485 11.3958 11.2499 11.8893 11.2499C12.3828 11.2499 12.7842 10.8485 12.7842 10.355C12.7842 9.86156 12.3828 9.46015 11.8893 9.46015ZM0.894895 9.46015C0.401433 9.46015 0 9.86156 0 10.355C0 10.8485 0.401416 11.2499 0.894895 11.2499C1.38837 11.2499 1.78979 10.8485 1.78979 10.355C1.78979 9.86156 1.38837 9.46015 0.894895 9.46015ZM11.8893 3.06818C11.3958 3.06818 10.9944 3.4696 10.9944 3.96308C10.9944 4.45655 11.3958 4.85797 11.8893 4.85797C12.3828 4.85797 12.7842 4.45655 12.7842 3.96308C12.7842 3.4696 12.3828 3.06818 11.8893 3.06818ZM0.894895 3.06818C0.401433 3.06818 0 3.4696 0 3.96308C0 4.45655 0.401416 4.85797 0.894895 4.85797C1.38837 4.85797 1.78979 4.45655 1.78979 3.96308C1.78979 3.4696 1.38837 3.06818 0.894895 3.06818ZM11.8893 5.36924C11.842 5.36924 11.796 5.36668 11.7499 5.36221V8.95582C11.796 8.95135 11.842 8.94879 11.8893 8.94879C12.0184 8.94879 12.1424 8.96797 12.2613 9.00057V5.3181C12.1424 5.3507 12.0184 5.36987 11.8893 5.36987V5.36924ZM7.57339 1.65485L10.6 3.40249C10.6697 3.24333 10.7675 3.0995 10.887 2.97805L7.76891 1.17805C7.73376 1.35064 7.66536 1.51172 7.57268 1.65554L7.57339 1.65485ZM0.895058 8.94878C0.942359 8.94878 0.988382 8.95134 1.0344 8.95581V5.3622C0.988382 5.36667 0.942359 5.36923 0.895058 5.36923C0.765939 5.36923 0.641929 5.35005 0.523047 5.31745V8.99992C0.641939 8.96732 0.765949 8.94815 0.895058 8.94815V8.94878ZM2.18369 3.40233L5.21031 1.65469C5.11763 1.51087 5.04923 1.35043 5.01408 1.1772L1.89599 2.9772C2.01616 3.09929 2.11395 3.24311 2.18299 3.40164L2.18369 3.40233ZM10.6008 10.9162L7.57355 12.6638C7.66623 12.807 7.73463 12.9681 7.76978 13.1407L10.8879 11.3407C10.7677 11.2186 10.6699 11.0748 10.6002 10.9162L10.6008 10.9162ZM5.21097 12.6638L2.18369 10.9162C2.11402 11.0753 2.01623 11.2192 1.89605 11.3406L5.01415 13.1406C5.0493 12.968 5.1177 12.807 5.21038 12.6638L5.21097 12.6638Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <Link className="nav-link btn-toggle align-items-center rounded fw-bold">
                      BlockChain
                    </Link>
                  </div>
                  {/* <img
                    src="/assets/images/shap/header-arrow.svg"
                    className={`arrow header_icon transition-rotate ${
                      openMenu === "contact" ? "rotate-180" : ""
                    }`}
                  /> */}
                  <i
                    className={`fa-solid fa-chevron-right header_icon transition-rotate ${
                      openMenu === "blockChain" ? "rotate-180" : ""
                    }`}
                  />
                </div>
                <div
                  className={`collapse ${
                    openMenu === "blockChain" ? "show" : ""
                  }`}
                  id="blockChain-collapse5"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-2 sub_menu">
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#blockchain-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            {/* <i class="bi bi-house-door-fill"></i> */}
                            <i className="bi bi-collection"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Blockchain
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="blockchain-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/blockchain_development"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Blockchain Development
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/metaverse_development"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Metaverse Development
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/web3development"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Web 3.0 Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#digital-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-coin"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Coin Development
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="digital-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/cryptocurrency"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Cryptocurrency Exchange
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/smartcontract"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Smart Contract Development
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/tokencoin"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Coin/Token Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#deFi-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-safe"></i>
                          </div>
                          <Link to="#" className="text_14">
                            DeFi
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="deFi-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/tokenization"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Asset Tokenization
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/defi"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              DeFi Development
                            </Link>
                          </li>
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              DeFi Development
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              DeFi Yield Farming
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              DeFi Staking
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              DeFi Lending And Borrowing
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              DeFi Lottery
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              DAO Blockchain
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Olympus DAO Development
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Dapp Development Services
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </li>

                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#frameworks-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-boxes"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Blockchain Frameworks
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="frameworks-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Parity Substrate
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Op Stack
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Arbitrum Orbit
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Polkadot Parachains
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Avalanche Subnets
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Cosmos SDK
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Polygon Zkevm
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Zksync Hyperchains
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#layer-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-layers"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Layer 1 & Layer 2 Solutions
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="layer-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              BSC
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Ethereum
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Solana
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Polkadot
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Cardano
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              SUI Blockchain Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#enterprise-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-building"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Enterprise Blockchain
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="enterprise-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Entertainment
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Education
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Supply Chain
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Finance
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Transport And Logistics
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Healthcare
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Real Estate
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Procure-To-Pay
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Carbon Credits
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#smart-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-file-earmark-code"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Smart Contract
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="smart-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Smart Contract Development
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Smart Contract Audit
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#tokenization-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-currency-bitcoin "></i>
                          </div>
                          <Link to="#" className="text_14">
                            Tokenization
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="tokenization-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Asset Tokenization
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Real Estate Tokenization
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Fund Tokenization Development Services
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Gold Tokenization
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              Asset Management
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="text_14">
                              White Label Tokenization
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#whitepaper-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-file-text"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Whitepaper
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="whitepaper-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              White Paper Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </li>
              {/* mobile view second menu */}
              <li
                className={`mb-1 mobile_nav_menus d-lg-none d-block ${
                  openMenu === "ai" ? "active" : ""
                }`}
              >
                <div
                  className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                  data-bs-toggle="collapse"
                  onClick={() => handleToggle("ai")}
                  data-bs-target="#ai-collapse5"
                  aria-expanded={openMenu === "ai"}
                >
                  <div className="d-flex align-items-center">
                    <div class="door_icon me-xxl-3 me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c-35.3 0-64 28.7-64 64l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c0 35.3 28.7 64 64 64l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c35.3 0 64-28.7 64-64l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c0-35.3-28.7-64-64-64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40zM160 128l192 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32zm192 32l-192 0 0 192 192 0 0-192z" />
                      </svg>
                    </div>
                    <Link className="nav-link btn-toggle align-items-center rounded fw-bold">
                      AI
                    </Link>
                  </div>
                  <i
                    className={`fa-solid fa-chevron-right header_icon transition-rotate ${
                      openMenu === "ai" ? "rotate-180" : ""
                    }`}
                  />
                </div>
                <div
                  className={`collapse ${openMenu === "ai" ? "show" : ""}`}
                  id="ai-collapse5"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-2 sub_menu">
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#artificial-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-cpu"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Artificial Intelligence
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="artificial-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              AI Ml Solutions
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#generative-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-palette"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Generative Ai
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="generative-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Generative Ai Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#agent-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-robot"></i>
                          </div>
                          <Link to="#" className="text_14">
                            AI Agents
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="agent-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/aidevelopment"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              AI Agent Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              {/* mobile view first menu */}
              {/* <li
                className={`mb-1 mobile_nav_menus d-lg-none d-block ${openMenu === "industries" ? "active" : ""
                  }`}
              >
                <div
                  className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                  data-bs-toggle="collapse"
                  onClick={() => handleToggle("industries")}
                  data-bs-target="#industries-collapse5"
                  aria-expanded={openMenu === "industries"}
                >
                  <div className="d-flex align-items-center">
                    <div class="door_icon me-xxl-3 me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M64 32C46.3 32 32 46.3 32 64l0 240 0 48 0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-128 0-151.8c0-18.2-19.4-29.7-35.4-21.1L352 215.4l0-63.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4 160 64c0-17.7-14.3-32-32-32L64 32z" />
                      </svg>
                    </div>
                    <Link className="nav-link btn-toggle align-items-center rounded fw-bold">
                      Industries
                    </Link>
                  </div>
                  <i
                    className={`fa-solid fa-chevron-right header_icon transition-rotate ${openMenu === "industries" ? "rotate-180" : ""
                      }`}
                  />
                </div>
                <div
                  className={`collapse ${openMenu === "industries" ? "show" : ""
                    }`}
                  id="industries-collapse5"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-2 sub_menu">
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#government-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-bank"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Government
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="government-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              G2C
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Digital Identity
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Government Data Storage
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              E-Voting System
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Government Regulatory Systems
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#bfsi-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-credit-card-2-front"></i>
                          </div>
                          <Link to="#" className="text_14">
                            BFSI
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="bfsi-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              CBDC
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              KYC & AML
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Trade Finance
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Insurance
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#cloud-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-cloud-check"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Cloud Services
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="cloud-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              AWS Services
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#case-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-journal-text"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Case Study
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="case-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Case Study
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li> */}
              {/* mobile view second menu */}
              <li
                className={`mb-1 mobile_nav_menus d-lg-none d-block ${
                  openMenu === "consulting" ? "active" : ""
                }`}
              >
                <div
                  className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                  data-bs-toggle="collapse"
                  onClick={() => handleToggle("consulting")}
                  data-bs-target="#consulting-collapse5"
                  aria-expanded={openMenu === "consulting"}
                >
                  <div className="d-flex align-items-center">
                    <div class="door_icon me-xxl-3 me-2">
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.0266 14.0492C9.96958 14.0492 9.92563 14.0025 9.92563 13.9469C9.92563 13.8899 9.96958 13.8446 10.0266 13.8446H11.3658C11.4228 13.8446 11.4669 13.8899 11.4669 13.9469C11.4669 14.0025 11.4228 14.0492 11.3658 14.0492H10.0266ZM10.0266 14.8884C9.96958 14.8884 9.92563 14.8431 9.92563 14.7861C9.92563 14.7292 9.96958 14.6838 10.0266 14.6838H11.3658C11.4228 14.6838 11.4669 14.7292 11.4669 14.7861C11.4669 14.8431 11.4228 14.8884 11.3658 14.8884H10.0266ZM12.8345 11.2646C12.4356 11.0523 11.9616 10.7971 11.4072 10.4823L9.9359 12.903C9.9307 12.9108 9.9256 12.9172 9.92043 12.925C9.88158 12.9665 9.81686 12.9691 9.77531 12.9302L9.00345 12.2101L8.14866 13.0597V13.061H8.14602V13.0623L8.14349 13.0636V13.0649V13.0662H8.14096V13.0674L8.13829 13.0688V13.07L8.13576 13.0714L8.13309 13.0726L8.12532 13.0765L8.12279 13.0778L8.12015 13.0791L8.11762 13.0804L8.11509 13.0817L8.11241 13.083L8.10985 13.0843H8.10718L8.10465 13.0856H8.10211L8.09944 13.0868H8.09691H8.09427L8.09174 13.0881H8.08921H8.08654H8.08401H8.08134H8.07624H8.07357H8.07104H8.0684H8.06587H8.0632L8.06067 13.0868H8.05813H8.05546L8.05293 13.0856H8.05026L8.04773 13.0843H8.0452L8.04003 13.0817L8.03483 13.0791L8.03229 13.0778L8.02962 13.0765L8.02709 13.0752L8.02189 13.0726V13.0714H8.01936L8.01672 13.0674H8.01419V13.0662V13.0649H8.01152V13.0636V13.0623H8.00899V13.061H8.00645V13.0597V13.0584H8.00378V13.0571V13.0558H8.00125V13.0545V13.0532L7.99861 13.052L7.99605 13.0494V13.0481L7.99352 13.0415L7.99088 13.0403L7.98835 13.0351L7.98568 13.0312L6.59212 10.485C6.02234 10.8088 5.53789 11.0665 5.13647 11.2802C4.20392 11.7788 3.7169 12.0379 3.47865 12.4251C3.21965 12.8473 3.22738 13.4586 3.24556 14.7317C3.25073 15.0931 3.25593 15.5049 3.25593 15.9284C5.17268 16.3662 7.08687 16.5799 9.0012 16.5773C10.9154 16.5747 12.8296 16.3546 14.7465 15.9284C14.7465 15.5205 14.7516 15.1177 14.7568 14.7628C14.7723 13.4767 14.7801 12.8589 14.5185 12.4316C14.2747 12.0365 13.7825 11.7723 12.8345 11.2646ZM9.13817 12.0547L9.82196 12.6945L11.2389 10.3619L10.7235 9.88923L9.13817 12.0547ZM6.76034 10.3645L8.10211 12.8188L8.86624 12.0573L7.27833 9.88926L6.76034 10.3645ZM9.05274 2.42141C8.28338 2.42141 7.58402 2.7336 7.07886 3.23869C6.67224 3.64534 6.39243 4.17637 6.29659 4.76823C6.30176 4.7825 6.30433 4.79931 6.30176 4.81485C6.29139 4.87957 6.28362 4.94563 6.28109 5.01169C6.27589 5.07648 6.27332 5.14384 6.27332 5.21246C6.27332 5.36269 6.28362 5.52328 6.30429 5.69164V5.69555C6.32511 5.86394 6.35622 6.04004 6.39507 6.21621C6.3976 6.22528 6.4002 6.23692 6.4002 6.24725C6.4002 6.25636 6.39763 6.26409 6.39763 6.27316C6.54529 6.91167 6.81722 7.59553 7.20331 8.15501C7.66428 8.82329 8.28595 9.30898 9.05274 9.30898C9.81943 9.30898 10.4436 8.82329 10.9047 8.15501C10.954 8.08248 11.0031 8.00735 11.0499 7.93096L9.49567 8.52155C9.41534 8.55132 9.33241 8.54746 9.25995 8.51504C9.18999 8.48263 9.12776 8.42307 9.09936 8.34408C9.06824 8.26508 9.07348 8.18088 9.10713 8.10969C9.1382 8.03716 9.19776 7.97757 9.27542 7.9478L11.4461 7.12148C11.7077 6.4545 11.8451 5.75514 11.8451 5.2125C11.8451 4.44187 11.5317 3.74378 11.0265 3.23869C10.5214 2.73356 9.82456 2.42141 9.05274 2.42141ZM6.83804 4.54805C6.81213 4.49883 6.83283 4.43667 6.88198 4.41076C6.9312 4.38485 6.99343 4.40559 7.01934 4.45478C7.07365 4.55842 7.13841 4.64778 7.21101 4.72418C7.43116 4.9586 7.73167 5.07514 8.03722 5.10366C8.34293 5.13217 8.65635 5.07128 8.89211 4.94953C8.97754 4.90548 9.05527 4.85366 9.11475 4.79411L9.11743 4.79277C9.65356 4.28508 9.853 4.19058 9.93857 4.27991L9.94367 4.28508C9.99559 4.34593 9.97995 4.43403 9.95924 4.5363C9.94367 4.61143 9.9256 4.69823 9.9411 4.73968V4.74228C9.95401 4.76299 10.0058 4.76173 10.1457 4.70987C10.3374 4.63734 10.6198 4.55054 10.8736 4.53891H10.8762C11.1611 4.52853 11.4098 4.60883 11.49 4.89507C11.5057 4.94946 11.472 5.00515 11.4175 5.02069C11.3632 5.03492 11.3062 5.00258 11.2932 4.9495C11.2465 4.78243 11.0782 4.73582 10.8839 4.74355H10.8814C10.6559 4.75392 10.3944 4.83425 10.2182 4.90028C9.93063 5.00645 9.80382 4.94559 9.75203 4.81998L9.74936 4.80961C9.71318 4.71507 9.73642 4.59719 9.75713 4.49619C9.76754 4.44697 9.80635 4.4366 9.79092 4.42106C9.78571 4.41456 9.6794 4.54281 9.25731 4.94173V4.94303C9.17948 5.01555 9.08881 5.07775 8.98524 5.1308C8.7158 5.27068 8.36354 5.33934 8.01911 5.30696C7.66681 5.27455 7.31975 5.1373 7.06061 4.8653C6.97529 4.776 6.90012 4.66979 6.83804 4.54805ZM9.82196 6.28223C9.77014 6.30424 9.71058 6.27967 9.68724 6.22785C9.66657 6.17603 9.68991 6.11647 9.7417 6.09443C9.74423 6.09313 10.3764 5.80952 10.6819 6.11647C10.7208 6.15532 10.7208 6.22134 10.6819 6.26149C10.6405 6.30034 10.5758 6.30034 10.537 6.26019C10.3323 6.05558 9.82456 6.28223 9.82196 6.28223ZM5.6076 4.90291C5.72415 3.92898 6.13864 3.06512 6.74216 2.44215C7.35596 1.80755 8.16684 1.42287 9.0527 1.42287C9.94114 1.42287 10.7518 1.80755 11.3658 2.44215C11.9693 3.06512 12.3838 3.92898 12.5003 4.90291H12.7697V6.14498H11.9563C12.0237 5.81079 12.0574 5.49224 12.0574 5.2125C12.0574 5.10886 12.0547 5.00525 12.0418 4.90295H12.2957C12.1792 3.98467 11.7881 3.17136 11.2182 2.58464C10.6405 1.98888 9.88411 1.62755 9.0527 1.62755C8.22379 1.62755 7.46477 1.98888 6.88979 2.58464C6.3199 3.17133 5.92622 3.98467 5.81221 4.90295H6.06347C6.05307 5.00525 6.04797 5.10886 6.04797 5.2125C6.04797 5.49224 6.08165 5.81082 6.15158 6.14498H5.3537V4.90291H5.6076ZM12.2542 6.67598C12.2542 6.61896 12.301 6.57234 12.358 6.57234C12.4148 6.57234 12.4589 6.61896 12.4589 6.67598V7.10338C12.4589 7.14999 12.4278 7.18888 12.3864 7.20178L9.42301 8.32984C9.36869 8.35055 9.3117 8.32337 9.29099 8.27158C9.27029 8.2185 9.29616 8.15891 9.35055 8.13947L12.2542 7.03342V6.67598H12.2542ZM8.36631 6.09443C8.4181 6.11647 8.44134 6.17606 8.4181 6.22785C8.39739 6.27967 8.33773 6.30424 8.28595 6.28223C8.28342 6.28223 7.77572 6.05558 7.57108 6.26019C7.53223 6.30034 7.46747 6.30034 7.42599 6.26149C7.38718 6.22134 7.38718 6.15532 7.42599 6.11647C7.73167 5.80952 8.36364 6.09313 8.36631 6.09443Z"
                          fill="black"
                        />
                      </svg> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M256 48C141.1 48 48 141.1 48 256l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C0 114.6 114.6 0 256 0S512 114.6 512 256l0 144.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24l-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40L464 256c0-114.9-93.1-208-208-208zM144 208l16 0c17.7 0 32 14.3 32 32l0 112c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-48c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64l0 48c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32l16 0z" />
                      </svg>
                    </div>
                    <Link className="nav-link btn-toggle align-items-center rounded fw-bold">
                      Gaming
                    </Link>
                  </div>

                  <i
                    className={`fa-solid fa-chevron-right header_icon transition-rotate ${
                      openMenu === "consulting" ? "rotate-180" : ""
                    }`}
                  />
                </div>
                <div
                  className={`collapse ${
                    openMenu === "consulting" ? "show" : ""
                  }`}
                  id="consulting-collapse5"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-2 sub_menu">
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#consultings-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          {/* <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-person-workspace "></i>
                          </div> */}
                          <ul>
                            <li className="">
                              <Link
                                to="/gaming"
                                className="text_14"
                                onClick={handleCloseMenu}
                              >
                                Gaming
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/* <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg> */}
                      </div>
                      {/* <div className="collapse" id="consultings-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Blockchain Consulting Company
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Web3 Consulting Company
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Metaverse Consulting Company
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              AI Consulting Company
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              DeFi Consulting Services
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              DAO Consulting Services
                            </Link>
                          </li>
                        </ul>
                      </div> */}
                    </li>
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#marketing-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-megaphone"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Marketing As A Service (MAAS)
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="marketing-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Marketing As A Service
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </li>
              {/* mobile view third menu */}
              <li
                className={`mb-1 mobile_nav_menus d-lg-none d-block ${
                  openMenu === "solutions" ? "active" : ""
                }`}
              >
                <div
                  className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                  data-bs-toggle="collapse"
                  onClick={() => handleToggle("solutions")}
                  data-bs-target="#solutions-collapse5"
                  aria-expanded={openMenu === "solutions"}
                >
                  <div className="d-flex align-items-center">
                    <div className="door_icon me-xxl-3 me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="19"
                        viewBox="0 0 13 19"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.80307 14.597H3.19727V14.937C3.19743 15.2307 3.31418 15.5123 3.52186 15.72C3.72954 15.9277 4.01117 16.0444 4.30487 16.0446H8.69507C8.98885 16.0445 9.27058 15.9278 9.47835 15.7201C9.68611 15.5125 9.80291 15.2308 9.80307 14.937V14.597ZM8.96307 16.5436C8.87467 16.5587 8.78515 16.5662 8.69547 16.566H4.30487C4.21526 16.5662 4.1258 16.5587 4.03747 16.5436C4.11965 17.0856 4.39284 17.5803 4.80773 17.9386C5.22262 18.2969 5.7519 18.495 6.30007 18.4974H6.70007C7.24824 18.495 7.77752 18.2969 8.19241 17.9386C8.60731 17.5803 8.88049 17.0856 8.96267 16.5436H8.96307ZM6.76007 6.99719V5.49279C6.81547 5.49799 6.87207 5.50039 6.92847 5.50039C7.33012 5.50039 7.71531 5.34083 7.99931 5.05683C8.28332 4.77282 8.44287 4.38763 8.44287 3.98599C8.44287 3.58434 8.28332 3.19915 7.99931 2.91514C7.71531 2.63114 7.33012 2.47159 6.92847 2.47159C6.87251 2.47111 6.81658 2.47445 6.76107 2.48159V0.502586C8.3686 0.569718 9.88799 1.25555 11.0017 2.41675C12.1153 3.57796 12.7371 5.12465 12.7371 6.73359C12.7371 6.82399 12.7353 6.91185 12.7317 6.99719H10.9517C10.8826 6.99761 10.8166 7.0253 10.7679 7.07423C10.7192 7.12316 10.6918 7.18935 10.6917 7.25839C10.6915 7.29474 10.699 7.33072 10.7137 7.36399C10.7484 7.46759 10.7662 7.57611 10.7665 7.68539C10.7665 7.94885 10.6618 8.20153 10.4755 8.38783C10.2892 8.57412 10.0365 8.67879 9.77307 8.67879C9.50961 8.67879 9.25693 8.57412 9.07063 8.38783C8.88433 8.20153 8.77967 7.94885 8.77967 7.68539C8.77939 7.62814 8.7842 7.57098 8.79407 7.51459C8.80406 7.4574 8.81878 7.40114 8.83807 7.34639C8.86115 7.28179 8.85776 7.2107 8.82866 7.14859C8.79955 7.08648 8.74708 7.03838 8.68267 7.01479C8.65422 7.00414 8.62423 6.9982 8.59387 6.99719H6.76007ZM0.269672 6.99719H1.72327C1.71695 6.94221 1.71381 6.88692 1.71387 6.83159C1.71387 6.43 1.8734 6.04485 2.15737 5.76089C2.44134 5.47692 2.82648 5.31739 3.22807 5.31739C3.62966 5.31739 4.0148 5.47692 4.29877 5.76089C4.58274 6.04485 4.74227 6.43 4.74227 6.83159C4.74233 6.88692 4.73919 6.94221 4.73287 6.99719H6.24007V5.17999C6.23828 5.14593 6.24359 5.11188 6.25567 5.07999C6.27893 5.01509 6.32691 4.96203 6.38915 4.93239C6.45139 4.90275 6.52283 4.89894 6.58787 4.92179C6.64173 4.94245 6.69755 4.95759 6.75447 4.96699C6.81172 4.97599 6.86953 4.98107 6.92747 4.98219C7.05804 4.98219 7.18732 4.95645 7.30794 4.90646C7.42855 4.85646 7.53813 4.78318 7.63041 4.69081C7.72268 4.59844 7.79585 4.48879 7.84573 4.36813C7.8956 4.24746 7.9212 4.11815 7.92107 3.98759C7.92028 3.72422 7.81538 3.47185 7.62924 3.28552C7.4431 3.0992 7.19084 2.99404 6.92747 2.99299C6.86933 2.9924 6.8113 2.9983 6.75447 3.01059C6.70377 3.0181 6.65379 3.02987 6.60507 3.04579C6.57208 3.06093 6.53617 3.06865 6.49987 3.06839C6.43085 3.06791 6.36482 3.0402 6.31612 2.99129C6.26743 2.94237 6.24003 2.87621 6.23987 2.80719V0.502586C4.63227 0.56957 3.11278 1.25535 1.99904 2.41658C0.885297 3.57781 0.263516 5.12459 0.263672 6.73359C0.263672 6.82399 0.265872 6.91199 0.269072 6.99719H0.269672ZM6.24007 7.51999V9.02699C6.1843 9.01983 6.1281 9.01649 6.07187 9.01699C5.67023 9.01699 5.28503 9.17654 5.00103 9.46054C4.71702 9.74455 4.55747 10.1297 4.55747 10.5314C4.55747 10.933 4.71702 11.3182 5.00103 11.6022C5.28503 11.8862 5.67023 12.0458 6.07187 12.0458C6.12847 12.0458 6.18467 12.0408 6.24007 12.0358V14.0772H3.19727V13.276C3.20119 12.9191 3.12759 12.5657 2.98156 12.2401C2.83553 11.9144 2.62055 11.6244 2.35147 11.39C1.69393 10.804 1.16728 10.086 0.805872 9.28279C0.555096 8.72285 0.388883 8.12876 0.312672 7.51999H2.04867C2.07897 7.52026 2.109 7.51426 2.13687 7.50239C2.20127 7.47883 2.25375 7.43078 2.28289 7.36872C2.31203 7.30665 2.31548 7.23558 2.29247 7.17099C2.25311 7.06198 2.23328 6.94688 2.23387 6.83099C2.23387 6.56747 2.33855 6.31474 2.52489 6.12841C2.71123 5.94207 2.96395 5.83739 3.22747 5.83739C3.49099 5.83739 3.74372 5.94207 3.93005 6.12841C4.11639 6.31474 4.22107 6.56747 4.22107 6.83099C4.22097 6.88902 4.21609 6.94695 4.20647 7.00419C4.19787 7.05456 4.18509 7.10413 4.16827 7.15239C4.15054 7.19213 4.14303 7.23567 4.14641 7.27906C4.14978 7.32245 4.16395 7.36431 4.18762 7.40083C4.21128 7.43735 4.2437 7.46738 4.28192 7.48819C4.32014 7.509 4.36295 7.51993 4.40647 7.51999H6.24007ZM12.6873 7.51999H11.2779C11.2838 7.57505 11.2867 7.6304 11.2867 7.68579C11.2867 8.08732 11.1272 8.47242 10.8432 8.75635C10.5593 9.04028 10.1742 9.19979 9.77267 9.19979C9.37113 9.19979 8.98604 9.04028 8.70211 8.75635C8.41818 8.47242 8.25867 8.08732 8.25867 7.68579C8.25875 7.63039 8.26182 7.57505 8.26787 7.51999H6.76007V9.35339C6.76007 9.38747 6.75334 9.42122 6.74026 9.4527C6.72718 9.48418 6.70801 9.51276 6.68385 9.53681C6.65969 9.56086 6.63102 9.5799 6.59948 9.59283C6.56794 9.60577 6.53416 9.61234 6.50007 9.61219C6.46993 9.61243 6.44 9.60729 6.41167 9.59699C6.35756 9.57753 6.30198 9.56242 6.24547 9.55179C6.18815 9.54377 6.13035 9.53956 6.07247 9.53919C5.80901 9.53919 5.55633 9.64385 5.37003 9.83015C5.18373 10.0164 5.07907 10.2691 5.07907 10.5326C5.07907 10.7961 5.18373 11.0487 5.37003 11.235C5.55633 11.4213 5.80901 11.526 6.07247 11.526C6.13048 11.5261 6.18837 11.521 6.24547 11.5108C6.30168 11.5 6.35718 11.4857 6.41167 11.4682C6.44354 11.4561 6.47751 11.4505 6.51158 11.4516C6.54565 11.4528 6.57915 11.4607 6.61011 11.475C6.64108 11.4893 6.66889 11.5096 6.69192 11.5347C6.71496 11.5598 6.73275 11.5893 6.74427 11.6214C6.75579 11.6534 6.76102 11.6874 6.75967 11.7214V14.0772H9.80307V13.276C9.79923 12.9191 9.8729 12.5657 10.019 12.24C10.1651 11.9144 10.3801 11.6244 10.6493 11.39C11.3066 10.804 11.8331 10.086 12.1943 9.28279C12.4451 8.72286 12.6114 8.12877 12.6877 7.51999H12.6873Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <Link className="nav-link btn-toggle align-items-center rounded fw-bold">
                      Solutions
                    </Link>
                  </div>
                  <i
                    className={`fa-solid fa-chevron-right header_icon transition-rotate ${
                      openMenu === "solutions" ? "rotate-180" : ""
                    }`}
                  />
                </div>
                <div
                  className={`collapse ${
                    openMenu === "solutions" ? "show" : ""
                  }`}
                  id="solutions-collapse5"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-2 sub_menu">
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#exchange-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i class="bi bi-arrow-left-right"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Exchange
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="exchange-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/exchange"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Custom Exchange
                            </Link>
                          </li>
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              White Label Exchange
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Derivatives Exchange
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Decentralized Exchange
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Centralized Exchange
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              P2P Exchange
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Margin Trading Exchangee
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Market Making Services
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Prediction Marketplaces
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#nft-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-image"></i>
                          </div>
                          <Link to="#" className="text_14">
                            NFT
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="nft-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/nftmarketplace"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              NFT Marketplace
                            </Link>
                          </li>
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              NFT Development
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              White Label NFT Marketplace
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              NFT Music
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Semi Fungible Token
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              NFT Art
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              NFT Generative Art
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              NFT Loan
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#bot-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="door_icon me-xxl-3 me-2">
                            <i className="bi bi-robot"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Trading Bots
                          </Link>
                        </div>
                        <svg
                          className="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="bot-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="/botdevelopment" className="text_14">
                              Arbitrage Bots
                            </Link>
                          </li>
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Flash Loan Arbitrage Bot
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to="#" className="text_14">
                              Trading Bot
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </li>
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#wallet-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-wallet2"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Wallet
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="wallet-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Digital Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Super App Development
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              DeFi Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Web3 Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              White Label Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Multicurrency Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              TRON Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              MPC Crypto Wallet
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              AI Crypto Wallet
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}

                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#web3-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-globe2"></i>
                          </div>
                          <Link to="#" className="text_14">
                            web3
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="web3-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Web 3.0 Development
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                    {/* <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#digital-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-credit-card"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Digital Banking
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="digital-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link to="#" className="text_14">
                              Digital Banking
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              White Label Banking
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              White Label Neo Bank
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              BaaS Development
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Payment Gateway
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              P2P Lending
                            </Link>
                          </li>
                          <li className="">
                            <Link to="#" className="text_14">
                              Stablecoin Remittance Platform
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </li>
              {/* mobile view five menu */}
              <li
                className={`mb-1 mobile_nav_menus d-lg-none d-block ${
                  openMenu === "about" ? "active" : ""
                }`}
              >
                <div
                  className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                  data-bs-toggle="collapse"
                  onClick={() => handleToggle("about")}
                  data-bs-target="#about-collapse5"
                  // aria-expanded="false"
                  aria-expanded={openMenu === "about"}
                >
                  <div className="d-flex align-items-center">
                    <div class="door_icon me-xxl-3 me-2">
                      {/* <i class="bi bi-house-door-fill"></i> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M15.6602 14.0184C15.6602 14.8558 15.43 15.5171 14.9699 16.0022C14.5097 16.4873 13.898 16.7299 13.1352 16.7299H10.8724C11.328 16.2763 11.6102 15.6487 11.6102 14.955C11.6102 13.5715 10.4887 12.4499 9.10518 12.4499C7.7217 12.4499 6.60012 13.5715 6.60012 14.955C6.60012 15.6487 6.88236 16.2763 7.33794 16.7299H4.86996C4.10712 16.7299 3.58764 16.4178 3.29154 16.0875C2.0112 14.6587 2.44428 12.2019 2.51052 11.7936C2.57658 11.3852 2.6601 11.0068 2.76108 10.6576C2.86188 10.3088 2.99742 9.96842 3.1677 9.63686C3.33798 9.3053 3.53328 9.0227 3.75414 8.78888C3.97482 8.55506 4.24428 8.3684 4.5627 8.22872C4.88094 8.08922 5.23248 8.0192 5.61714 8.0192C5.67384 8.0192 5.80632 8.09426 6.0144 8.24438C6.22248 8.3945 6.4572 8.56208 6.71892 8.74694C6.98046 8.93198 7.32084 9.09956 7.74024 9.2495C8.15946 9.39962 8.5803 9.47468 9.00276 9.47468C9.42504 9.47468 9.8457 9.39962 10.2653 9.2495C10.6845 9.09956 11.0249 8.93198 11.2866 8.74694C11.5481 8.56208 11.783 8.3945 11.9911 8.24438C12.1992 8.09444 12.3315 8.0192 12.3884 8.0192C12.7729 8.0192 13.1244 8.08904 13.4428 8.22872C13.7611 8.3684 14.0307 8.55506 14.2514 8.78888C14.4719 9.0227 14.6675 9.30548 14.8378 9.63686C15.0081 9.96824 15.1435 10.3086 15.2444 10.6576C15.3452 11.0067 15.4288 11.3852 15.495 11.7936C15.5612 12.202 15.6052 12.5826 15.6275 12.9348C15.6491 13.2873 15.6602 13.6483 15.6602 14.0184ZM9.00024 0.648743C7.95048 0.648743 7.05426 1.04132 6.31176 1.82648C5.56926 2.61164 5.19774 3.55916 5.19774 4.66904C5.19774 5.77892 5.56908 6.72626 6.31176 7.5116C7.05444 8.29694 7.95066 8.68934 9.00024 8.68934C10.0498 8.68934 10.946 8.29676 11.6887 7.5116C12.4314 6.72644 12.8027 5.77892 12.8027 4.66904C12.8027 3.55916 12.4314 2.61182 11.6887 1.82648C10.946 1.04114 10.05 0.648743 9.00024 0.648743ZM10.2925 12.8814C9.92544 12.6672 9.52476 12.5601 9.09006 12.5601C8.65572 12.5601 8.25504 12.6672 7.88802 12.8814C7.521 13.0956 7.23048 13.3859 7.0161 13.7529C6.8019 14.1199 6.69498 14.5206 6.69498 14.9551C6.69498 15.3897 6.8019 15.7903 7.0161 16.1574C7.2303 16.5244 7.521 16.8147 7.88802 17.0289C8.25504 17.2429 8.65572 17.35 9.09006 17.35C9.52476 17.35 9.92544 17.2429 10.2925 17.0289C10.6589 16.8147 10.9496 16.5244 11.1638 16.1574C11.378 15.7903 11.4853 15.3897 11.4853 14.9551C11.4853 14.5206 11.378 14.1199 11.1638 13.7529C10.9496 13.3859 10.6591 13.0956 10.2925 12.8814ZM10.2489 14.609C10.2224 14.6859 10.1938 14.7489 10.1616 14.7975C10.1294 14.8464 10.0829 14.8965 10.0228 14.9474C9.96234 14.9983 9.91464 15.0347 9.87918 15.0565C9.84372 15.0783 9.79278 15.108 9.72636 15.1452C9.6576 15.1848 9.60126 15.2365 9.55626 15.2997C9.51162 15.363 9.48948 15.4147 9.48948 15.4541C9.48948 15.4833 9.47994 15.507 9.46122 15.5259C9.4425 15.5446 9.41892 15.5538 9.38976 15.5538H8.79072C8.76156 15.5538 8.73744 15.5445 8.7189 15.5259C8.70018 15.507 8.69118 15.4831 8.69118 15.4541V15.3418C8.69118 15.2026 8.74572 15.0721 8.85498 14.9505C8.96424 14.8288 9.08412 14.739 9.21516 14.6808C9.3147 14.6351 9.38526 14.5883 9.42702 14.5406C9.46842 14.4929 9.4893 14.4294 9.4893 14.3503C9.4893 14.2819 9.45024 14.2206 9.37248 14.1664C9.29418 14.1126 9.20562 14.0854 9.1059 14.0854C8.99772 14.0854 8.90808 14.1102 8.83752 14.1603C8.76876 14.2101 8.6793 14.3059 8.56914 14.447C8.55042 14.472 8.5245 14.4844 8.49138 14.4844C8.46636 14.4844 8.44638 14.4783 8.4318 14.4657L8.02014 14.1538C7.97244 14.1165 7.96416 14.0728 7.99512 14.0227C8.2617 13.5799 8.64726 13.3585 9.15216 13.3585C9.33324 13.3585 9.51 13.4012 9.68244 13.4863C9.85524 13.5717 9.99906 13.6924 10.1144 13.8481C10.23 14.0042 10.2872 14.1736 10.2872 14.3566C10.2874 14.4479 10.2748 14.532 10.2489 14.609ZM9.46104 16.5237C9.44232 16.5424 9.41874 16.5519 9.38958 16.5519H8.79054C8.76138 16.5519 8.73726 16.5424 8.71872 16.5237C8.7 16.5049 8.691 16.4812 8.691 16.452V15.8533C8.691 15.8242 8.70018 15.8001 8.71872 15.7815C8.73744 15.7628 8.76138 15.7536 8.79054 15.7536H9.38958C9.41874 15.7536 9.44232 15.763 9.46104 15.7815C9.47976 15.8002 9.4893 15.8242 9.4893 15.8533V16.452C9.4893 16.4812 9.47976 16.5051 9.46104 16.5237Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <Link className="nav-link btn-toggle align-items-center rounded fw-bold">
                      About Us
                    </Link>
                  </div>
                  {/* <img
                    src="/assets/images/shap/header-arrow.svg"
                    className={`arrow header_icon transition-rotate ${
                      openMenu === "contact" ? "rotate-180" : ""
                    }`}
                  /> */}
                  <i
                    className={`fa-solid fa-chevron-right header_icon transition-rotate ${
                      openMenu === "about" ? "rotate-180" : ""
                    }`}
                  />
                </div>
                <div
                  className={`collapse ${openMenu === "about" ? "show" : ""}`}
                  id="about-collapse5"
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-2 sub_menu">
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#company-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-buildings"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Company
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="company-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/about"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              About Us
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/partners"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Partners
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/contact"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Contact Us
                            </Link>
                          </li>
                          <li className="">
                            <Link
                              to="/productdetails"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Product Details
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#blog-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-newspaper"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Blogs
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="blog-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/blog"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Blogs
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div
                        className="d-flex align-items-center navbar_padding justify-content-between fullwidth-dropdown wrapper arrow_icon"
                        data-bs-toggle="collapse"
                        data-bs-target="#career-inside"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div class="door_icon me-xxl-3 me-2">
                            <i class="bi bi-briefcase"></i>
                          </div>
                          <Link to="#" className="text_14">
                            Career
                          </Link>
                        </div>
                        <svg
                          class="arrow"
                          width="14"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                        >
                          <path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z" />
                        </svg>
                      </div>
                      <div className="collapse" id="career-inside">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small pb-1 px-4 mega_menu">
                          <li className="">
                            <Link
                              to="/career"
                              className="text_14"
                              onClick={handleCloseMenu}
                            >
                              Career
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>

            <div class="d-flex align-items-center gap-3">
              <a href="/contact">
                <button class="button theme_btn mt-4 mt-lg-0" type="submit">
                  Get In Touch
                </button>
              </a>

              <div className="d-none d-lg-block">
                <label htmlFor="switch" className="toggle_btn">
                  <input
                    type="checkbox"
                    className="input"
                    id="switch"
                    onChange={toggleTheme}
                    checked={theme === "dark"}
                    readOnly
                  />
                  <div
                    className={`icon icon--moon ${
                      theme === "light" ? "show" : "hide"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="#000"
                      width={25}
                      height={25}
                    >
                      <path
                        fillRule="evenodd"
                        d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div
                    className={`icon icon--sun ${
                      theme === "dark" ? "show" : "hide"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="#000"
                      width={25}
                      height={25}
                    >
                      <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
                    </svg>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
